import { render, staticRenderFns } from "./RepresentativeRegistration.vue?vue&type=template&id=070a36b2"
import script from "./RepresentativeRegistration.vue?vue&type=script&lang=js"
export * from "./RepresentativeRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports